import { render, staticRenderFns } from "./CategoryCustomer.vue?vue&type=template&id=d736bbca&"
import script from "./CategoryCustomer.vue?vue&type=script&lang=js&"
export * from "./CategoryCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports